import React, { useRef } from 'react';
import { Row } from 'reactstrap';
import moment from 'moment/moment';
import { useReactToPrint } from 'react-to-print';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import CardRelatorio from '../components/CardRelatorio';

//Context
import { useAuth } from '../../../context/auth';

export default function RelatorioColetasPorGerador({ dadosRelatorio, btnVoltar, filtros }) {
    const { session, setupVariavel } = useAuth();

    const refRelatorio = useRef();
    
    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersColetas = [
        { value: `Nº ${setupVariavel?.siglaDocumentoColeta}`, objectValue: "item_Coleta", col: "4" },
        { value: "STATUS DO CONTRATO", objectValue: "contrato", col: "4" },
        { value: "LOCAL DA COLETA", objectValue: "local_Coleta", col: "12" },

        { value: "TRANSPORTADOR", objectValue: "nome_Transportador", col: "4" },
        { value: "PLACA/IMPLEMENTO", objectValue: "veiculo", col: "3" },
        { value: "COLETADO", objectValue: "volume", col: "4" },


        { value: "DESTINO FINAL", objectValue: "nome_Destino", col: "6" },
        { value: "STATUS", objectValue: "status_Coleta", col: "6" },

        { value: "DATA/HORA DA COLETA", formatDate: true, objectValue: "data_Coleta", col: "6" },
        { value: "DATA/HORA DO RECEBIMENTO DO DF", formatDate: true, objectValue: "data_Descarte", col: "6" },

        { value: "MODALIDADE DE COLETA", objectValue: "tipo_Coleta", col: "12" },
        { value: "RESÍDUOS", objectValue: "residuo", col: "12" },
    ];
    //Cabeçalhos para a listagem dos manivefestos de residuos por meio do cardRelatorio
    const headersManifestoDeResiduos = [
        { value: "IMPLEMENTO", objectValue: "implemento", col: "4" },
        { value: "QUANTIDADE DE IMPLEMENTOS", objectValue: "total_Implemento", col: "4" },
        { value: "PORCENTAGEM", objectValue: "porcentagem_Implemento", col: "4" },
    ];
    //Cabeçalhos para a listagem dos totalizadores de residuos solidos por meio do cardRelatorio
    const headersTotalizadoresResiduosSolidos = [
        { value: "MODALIDADE DE COLETA", objectValue: "modalidade", col: "6" },
        { value: "TIPO DE RESÍDUOS", objectValue: "tipoResiduo", col: "6" },

        { value: "INFORMADO", objectValue: "qtde_Informada_Contrado", col: "6" },
        { value: "GERADO", objectValue: "totalGerado", col: "6" },
    ];
    //Cabeçalhos para a listagem dos totalizadores por status e modalidade usando o cardRelatorio
    const headersTotalizadoresPorStatusEModalidade = [
        { value: "TITULO", objectValue: "titulo", col: "6" },
        { value: "QUANTIDADE", objectValue: "quantidade", col: "6" },
    ];
    //Cabeçalhos para a listagem dos totalizadores por regional/bairro usando o cardRelatorio
    const headersTotalizadoresRegionalBairro = [
        { value: "REGIONAL", objectValue: "regional", col: "4" },
        { value: "BAIRRO", objectValue: "bairro", col: "4" },
        { value: "N° DE GERADORES", objectValue: "total", col: "4" },
    ];
    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório detalhado por transportador",
    });

    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint}>
            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                 {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%'}} />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Relatório de coletas por gerador</h4>
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                        </div>
                        <div className='col-4'>
                            <p><span className="fw-bold">Status Coletas:</span> {filtros.status}</p>
                        </div>
                    </Row>
                    <Row>
                        <div className='col-4'>
                            {filtros.geradorId_selected
                                ?
                                <p><span className="fw-bold">Gerador:</span> {filtros.geradorId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Gerador:</span> Todos</p>
                            }
                        </div>
                        <div className='col-4'>
                            {filtros.modalidadeId_selected
                                ?
                                <p><span className="fw-bold">Modalidade:</span> {filtros.modalidadeId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Modalidade:</span> Todas</p>
                            }
                        </div>
                        <div className='col-4'>
                            {filtros.localidadeId_selected
                                ?
                                <p><span className="fw-bold">Localidade:</span> {filtros.localidadeId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Localidade:</span> Todas</p>
                            }
                        </div>
                    </Row>
                </div>
                <div className="body">
                    <h5 className='rounded-3 bg-secondary text-light p-2'>Dados do gerador</h5>
                    <Row className='content-rel'>
                        <div className="col-6"><span className="fw-bold">Nome:</span> {dadosRelatorio.gerador.fantasia}</div>
                        <div className="col-6"><span className="fw-bold">CNPJ:</span> {dadosRelatorio.gerador.cpfcnpj}</div>
                        <div className="col-4"><span className="fw-bold">Responsável:</span> {dadosRelatorio.gerador.contato}</div>
                        <div className="col-4"><span className="fw-bold">E-mail:</span> {dadosRelatorio.gerador.email}</div>
                        <div className="col-4"><span className="fw-bold">Telefone:</span> {dadosRelatorio.gerador.fone}</div>
                        <div className="col-4"><span className="fw-bold">Celular:</span> {dadosRelatorio.gerador.celular}</div>
                        <div className="col-4"><span className="fw-bold">CEP:</span> {dadosRelatorio.gerador.cep}</div>
                        <div className="col-4"><span className="fw-bold">Cidade:</span> {dadosRelatorio.gerador.cidade}</div>
                        <div className="col-4"><span className="fw-bold">UF:</span> {dadosRelatorio.gerador.uf}</div>
                        <div className="col-4"><span className="fw-bold">Bairro:</span> {dadosRelatorio.gerador.bairro}</div>
                        <div className="col-4"><span className="fw-bold">Rua:</span> {dadosRelatorio.gerador.logradouro}</div>
                        <div className="col-4"><span className="fw-bold">Numero:</span> {dadosRelatorio.gerador.numero}</div>
                    </Row>
                    <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>Coletas</h5>
                    <CardRelatorio headers={headersColetas} items={dadosRelatorio.listaColetas} />
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>MANIFESTOS DE TRANSPORTE DE RESÍDUOS</h5>
                        <p className='p-1 border-bottom'><span className="fw-bold">TOTAL DE {setupVariavel?.siglaDocumentoColeta}s LANÇADAS: </span>{dadosRelatorio.dadosManifestos[0]?.total_MTR}</p>
                        <h5 className='p-1 border-bottom fw-bold'>IMPLEMENTO RODOVIÁRIO</h5>
                        <CardRelatorio headers={headersManifestoDeResiduos} items={dadosRelatorio.dadosManifestos} />
                        <h5 className='p-1 border-bottom fw-bold'>STATUS</h5>
                        <div className=" row ">

                            <div className="p-1 col-4 border-bottom">
                                <p className=' '><span className="fw-bold">COLETADO: </span></p>

                            </div>
                            <div className="p-1 col-4 border-bottom">
                                {dadosRelatorio.dadosManifestos[0]?.total_Coletado}
                            </div>
                            <div className="p-1 col-4 border-bottom">
                                {dadosRelatorio.dadosManifestos[0]?.porcentagem_Coletado}
                            </div>
                            <div className="p-1 col-4 border-bottom">
                                <p><span className="fw-bold">RECEBIDO: </span></p>

                            </div>
                            <div className="p-1 col-4 border-bottom">
                                {dadosRelatorio.dadosManifestos[0]?.total_Baixado}
                            </div>
                            <div className="p-1 col-4 border-bottom">
                                {dadosRelatorio.dadosManifestos[0]?.porcentagem_Baixado}
                            </div>
                        </div>

                    </div>
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>RESÍDUOS SÓLIDOS</h5>
                        <CardRelatorio headers={headersTotalizadoresResiduosSolidos} items={dadosRelatorio.totalizadoresResiduosSolidos} />
                        <p className='p-1 border-bottom'><span className="fw-bold">TOTAL: </span>{dadosRelatorio.totalizadoresResiduosSolidos[0]?.totalGerado}</p>
                    </div>
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>TOTALIZADORES DE {setupVariavel?.siglaDocumentoColeta}S POR STATUS E MODALIDADE</h5>
                        <CardRelatorio headers={headersTotalizadoresPorStatusEModalidade} items={dadosRelatorio.totalizadoresStatusModalidade} />

                    </div>
                    <div className="contentGroup">
                        <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>TOTALIZADOR POR REGIONAL/BAIRRO  </h5>
                        <CardRelatorio headers={headersTotalizadoresRegionalBairro} items={dadosRelatorio.totalizadoresRegionalBairro} />
                        <p className='p-1 border-bottom'><span className="fw-bold">TOTAL: </span>{dadosRelatorio.totalizadoresRegionalBairro[0]?.total}</p>
                    </div>
                </div>
            </div>
        </MainCard>
    )
}